import { useEffect, useRef } from 'react';
import axios from 'axios';
import type { AxiosInstance } from 'axios';
import config from "../business/config.json"

import { useKeycloak } from '@react-keycloak/web';

export const cancelTokenSource = axios.CancelToken.source();
const standardURL = config.api_domain;
export const useAxios = (baseURL?: string) => {
    const axiosInstance = useRef<AxiosInstance>();
    const { keycloak, initialized } = useKeycloak();
    const kcToken = (keycloak?.token) ?? 'no token';

    useEffect(() => {
        let url;
        if (typeof baseURL === "undefined") {
            url = standardURL;
        } else {
            url = baseURL
        }
        axiosInstance.current = axios.create({
            baseURL: url,
            headers: {
                Authorization: initialized ? `Bearer ${kcToken}` : undefined,
            }
        });

        return () => {
            axiosInstance.current = undefined;
        };
    }, [keycloak, baseURL, initialized, kcToken]);

    return axiosInstance;
};

export const useAxiosExternalAPI = (baseURL: string, token: string) => {
    const axiosInstance = useRef<AxiosInstance>();

    useEffect(() => {
        axiosInstance.current = axios.create({
            baseURL,
            // headers: {
            //     Authorization: token ? `Bearer ${token}` : undefined,
            //     "Access-Control-Allow-Origin": "*",
            //     "Access-Control-Allow-Headers": "authorization"
            // },
        });

        return () => {
            axiosInstance.current = undefined;
        };
    }, [baseURL]);

    return axiosInstance;
}